module.exports = __webpack_public_path__ + "static/33-b641b267f0da792d1ad033f7ba29309b.gif";